// в константы выносим только названия мутаций,
// которые переиспользуем/планируем переиспользовать
export const SET_COMPONENT_NAME = 'SET_COMPONENT_NAME';

const store = {
  namespaced: true,
  state: {
    component: null,
    value: undefined,
  },
  mutations: {
    SET_COMPONENT_NAME(state, name) {
      state.component = name;
    },
    SET_MODAL_COMPONENT_VALUE(state, value) {
      state.value = value;
    },
  },
  actions: {
    toggleModal({ commit, state }, payload) {
      const [name, value] = payload;
      if (value) commit('SET_MODAL_COMPONENT_VALUE', value);
      if (state.component === name) commit(SET_COMPONENT_NAME, null);
      else commit(SET_COMPONENT_NAME, name);
    },
  },
};

export default store;
